var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1211 30.5432C18.9625 30.8414 17.7478 31 16.4961 31C8.48797 31 1.99609 24.5081 1.99609 16.5C1.99609 8.49187 8.48797 2 16.4961 2C23.8904 2 29.992 7.53481 30.8839 14.6875M3.8086 21.9375H8.03776C9.70613 21.9375 11.0586 20.585 11.0586 18.9167V14.9896C11.0586 13.3212 12.4111 11.9688 14.0794 11.9688H17.1003C18.7686 11.9688 20.1211 10.6163 20.1211 8.94792V3.8125M29.2555 25.5959L33.4063 24.1608C34.1844 23.8918 34.2104 22.801 33.446 22.4952L23.1549 18.3781C22.439 18.0917 21.7228 18.7902 21.9913 19.5131L25.9116 30.0683C26.198 30.8396 27.2884 30.8414 27.5773 30.0709L29.2555 25.5959Z",
    stroke: "#2337A9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldPointer);
export default __webpack_public_path__ + "static/media/worldPointer.f9170477e9ea0951773a6e83e9b0eaef.svg";
export { ForwardRef as ReactComponent };